export const BASKET_INCREMENT_QUANTITY = 'BASKET_INCREMENT_QUANTITY';
export const BASKET_DECREMENT_QUANTITY = 'BASKET_DECREMENT_QUANTITY';
export const BASKET_SAVE = 'BASKET_SAVE';
export const BASKET_SAVE_SUCCESS = 'BASKET_SAVE_SUCCESS';
export const BASKET_SAVE_ERROR = 'BASKET_SAVE_ERROR';
export const BASKET_FETCH = 'BASKET_FETCH';
export const BASKET_FETCH_SUCCESS = 'BASKET_FETCH_SUCCESS';
export const BASKET_FETCH_ERROR = 'BASKET_FETCH_ERROR';
